import MarkAsApproved from './MarkAsApproved';

export default MarkAsApproved;
